import {
  ScrollArea as MantineScrollArea,
  ScrollAreaProps,
} from '@mantine/core';

export type IScrollAreaProps = ScrollAreaProps;

/** @registry Design-layer pass-through over Mantine ScrollArea; import this instead of @mantine/core ScrollArea outside src/design. Compound statics (ScrollArea.Autosize) are preserved. */
export const ScrollArea = MantineScrollArea;
